/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'

import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router';

import { DndProvider } from 'react-dnd';
import Backend from 'react-dnd-html5-backend';

import createStore, { history, appStore } from 'redux/store'
import ConnectedIntlProvider from './ConnectedIntlProvider';

import ColorThemeStyle, { ProfileThemeStyle } from 'components/common/ColorThemeStyle'
import SystemNotification from 'components/features/SystemNotification'
import SystemModal from 'components/modal/SystemModal';

import actions from './actions';
import userActions from 'redux/actions/user';

import Authentication from './Authentication';

import AppUtils from 'lib/AppUtils';
import api from 'api';
import AccessTokenModel from 'models/AccessTokenModel';
import { authToken } from 'lib/storagePolyfill';
import sessionActions from 'redux/actions/session';
import { SetupGlobalNav } from "../../redux/actions/navigation";
import { ModalContainer } from "../modal/ConfirmDeleteContentModal";

import UserMetrics from 'lib/UserMetrics';

UserMetrics.init();

appStore.dispatch(actions.loadInitialData(AppUtils.getGroupSubdomain()));

class App extends React.Component {

  constructor(props) {
    super(props);

    this.onScrollHandler = window.addEventListener('scroll', this.handleOnScoller);

    this.state = {
      isLoaded: false,
      isScrolled: false,
    };
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScrollHandler);
    this.onScrollHandler = null;
  }

  handleOnScoller = (e) => {
    const isScrolled = window.scrollY > 30;

    if (isScrolled !== this.state.isScrolled) {
      this.setState({ isScrolled }, () => {
        const el = document.getElementById('app');
        if (isScrolled) {
          el.classList.add('global-is-scrolled');
        } else {
          el.classList.remove('global-is-scrolled');
        }
      })
    }
  }

  UNSAFE_componentWillMount() {
    const savedToken = authToken.get();
    const tokenFromUrl = window.location.pathname.split('/token/')[1];

    if (tokenFromUrl) {
      // all tokens assume you are logged out
      AppUtils.clearSavedData();
      authToken.set(tokenFromUrl);

      api.sessionApi.get(tokenFromUrl)
        .then(session => {
          const userData = session.user;
          appStore.dispatch(userActions.receive(userData));
          this.setState({ isLoaded: true });
        })
        .catch(err => {
          AppUtils.clearSavedData();
          this.setState({ isLoaded: true });
        });
      return;
    } else if (!savedToken) {
      this.setState({ isLoaded: true });
      return;
    }

    let accessToken;

    api.sessionApi.get(savedToken)
    .then(accessData => {
      accessToken = new AccessTokenModel(accessData);
      if (accessToken.requiresMfa()) {
        return Promise.reject();
      } else {
        return accessToken.userId();
      }
    }).then((userId) => appStore.dispatch(userActions.request(userId)))
    .then(() => {
      appStore.dispatch(sessionActions.loginSuccessful(accessToken.data));
      this.setState({ isLoaded: true });
    }).catch((err) => {
      AppUtils.clearSavedData();
      this.setState({ isLoaded: true });
    });
  }

  render() {
    return (
      <Provider store={appStore}>
        <ConnectedIntlProvider>
          <DndProvider backend={Backend}>
            <ConnectedRouter history={history}>
              <SetupGlobalNav store={appStore}>
                <ModalContainer>
                  <div style={{ height: '100%' }}>
                    <ColorThemeStyle />
                    <ProfileThemeStyle />

                    <SystemNotification />
                    <SystemModal />

                    {
                      this.state.isLoaded ? <Authentication /> : null
                    }
                  </div>
                </ModalContainer>
              </SetupGlobalNav>
            </ConnectedRouter>
          </DndProvider>
        </ConnectedIntlProvider>
      </Provider>
    )
  }
}

export default App
